exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background-png {\r\n  width: 200px;\r\n  max-width: 100%;\r\n  background-color: #fff;\r\n  background-image: -webkit-linear-gradient(45deg,#efefef 25%,transparent 25%,transparent 75%,#efefef 75%,#efefef),-webkit-linear-gradient(45deg,#efefef 25%,transparent 25%,transparent 75%,#efefef 75%,#efefef);\r\n  background-position: 0 0,10px 10px;\r\n  -webkit-background-size: 21px 21px;\r\n  -webkit-box-shadow: 0 5px 35px rgba(0,0,0,.65);\r\n          box-shadow: 0 5px 35px rgba(0,0,0,.65);\r\n  border: 0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/padriana/gorent-panel/src/app/dashboard/shared/upload/upload.component.css
// module id = ../../../../../src/app/dashboard/shared/upload/upload.component.css
// module chunks = main